import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme } from "@mui/material";
import React from "react";
import { useKey } from "react-use";
import { BackdropModal } from "./BackdropModal.js";
import { GalleryRow } from "./GalleryRow.js";
import { GallerySlider } from "./GallerySlider.js";
import { useScreenWidth } from "../hooks/useScreenWidth.js";
export function GalleryModal({ images, initialIndex, handleClose, handleAdd, handleDelete, handleRotate, disabled, notInStack = true, downloadTitle, addTitle, deleteTitle, rotateTitle, arButtonTitle, }) {
    const theme = useTheme();
    const [isTop, setIsTop] = React.useState(true);
    const { isMaxPhone, isMinLargeDesktop } = useScreenWidth();
    const [currentIndex, setCurrentIndex] = React.useState(initialIndex ?? 0);
    React.useEffect(() => {
        if (!images[currentIndex])
            return;
        document
            .getElementById(`msys-image-thumbnail-${images[currentIndex].id}`)
            ?.scrollIntoView({ behavior: "smooth" });
    }, [images, currentIndex]);
    const moveNext = React.useCallback(() => {
        setCurrentIndex(index => (index + 1) % images.length);
    }, [images]);
    const movePrev = React.useCallback(() => {
        setCurrentIndex(index => (index - 1 + images.length) % images.length);
    }, [images]);
    React.useEffect(() => {
        if (images.length === 0)
            handleClose();
    }, [images.length, handleClose]);
    useKey("ArrowLeft", isTop ? movePrev : undefined, undefined, [isTop]);
    useKey("ArrowRight", isTop ? moveNext : undefined, undefined, [isTop]);
    return (_jsxs(BackdropModal, { handleClose: handleClose, notInStack: notInStack, onTopChange: setIsTop, children: [_jsx(GallerySlider, { images: images, slideIndex: currentIndex, onSlideIndexChange: setCurrentIndex, handleAdd: handleAdd, handleRotate: handleRotate, handleDelete: handleDelete, disabled: disabled, downloadTitle: downloadTitle, addTitle: addTitle, deleteTitle: deleteTitle, rotateTitle: rotateTitle, threeDInteractive: true, arButtonTitle: arButtonTitle }), _jsx(Box, { sx: {
                    overflowX: "auto",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                    flexGrow: 0,
                    flexShrink: 0,
                }, children: _jsx(GalleryRow, { idPrefix: `msys-image-thumbnail-`, selectedIndex: currentIndex, handleClick: index => setCurrentIndex(index), images: images, imageHeight: isMaxPhone
                        ? theme.layout.imageSize.xs
                        : isMinLargeDesktop
                            ? theme.layout.imageSize.xl
                            : theme.layout.imageSize.md, style: { margin: "0 auto" } }) })] }));
}
//# sourceMappingURL=GalleryModal.js.map